<div class="container" #clockInOutPage style="padding-top: 50px;">
    <div class="row">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block "></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            <div class="alert alert-warning" *ngIf="requestingLocation  && !clockActionPerformed">
                <span style="font-size: 18px;">Obtaining Location</span>
            </div>
            <div *ngIf="!requestingLocation && !clockActionPerformed">
                <span *ngIf="!geolocationEnabled" class="alert alert-danger" style="font-size: 18px;">Location Not Available</span>
                <span *ngIf="position != null" class="alert alert-success" style="font-size: 18px;">Location Found.&nbsp;<span *ngIf="showProcessing()">Processing...</span></span>
            </div>
            <div *ngIf="mealBreak && !canMealBreakClockIn()">
                <span class="alert alert-danger">
                    You last clocked out on your meal break at {{lastClockDisplay}}. You must wait {{mealBreakSetting[employeeInfo.PRCo + ',' + employeeInfo.PRGroup]}} minutes after clocking out before clocking in from a meal break.
                </span>
            </div>
            <div *ngIf="alert" class="alert" [ngClass]="'alert-' + (alert.type || 'default')" role="alert">
                {{alert.msg}}
                <button type="button" class="close" (click)="closeAlert()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div *ngIf="clockActionPerformed && !hasWarning">
                <span *ngIf="!clockActionSuccess" class="alert alert-danger" style="font-size: 18px;">{{message}}</span><br />
                <div *ngIf="clockActionSuccess" class="alert alert-success" style="display: block">
                    <span style="font-size: 18px;">{{message}}</span><br />
                    <span style="font-size: 18px;">Redirecting back to login page...</span>
                </div>
            </div>
            <div *ngIf="clockStatus && showMealBreak() && !clockActionPerformed">
                <label><strong>Meal Break:</strong></label>
                <ng-select [(ngModel)]="formData.mealBreak" name="mealBreak" [items]="mealBreakOptions" bindLabel="DisplayValue" bindValue="DatabaseValue" [clearable]="false" style="margin-bottom: 12px;">
                </ng-select>
            </div>
            <button (click)="performLoginRedirect()" class="btn btn-primary" style="margin-top:12px;" *ngIf="clockActionPerformed && (!clockActionSuccess || hasWarning)">Back</button>
            <a href="/Home/Index" class="btn btn-primary" *ngIf="!kioskLogin && clockActionPerformed && clockActionSuccess" style="margin-top:12px;">Stay logged in</a>
            <!--Regular clock handling if not restricted by meal break-->
            <ng-container *ngIf="showRegularClockInButtons()">
                <button type="button" class="btn btn-danger" [disabled]="performingClockAction"
                        *ngIf="(requestingLocation || !geolocationEnabled)"
                        (click)="postClockAction(true)">
                    Clock In/Out Without Location
                </button>
                <button type="button" class="btn btn-success" [disabled]="performingClockAction"
                        *ngIf="(!requestingLocation && position != null)"
                        (click)="postClockAction(false)">
                    Clock In/Out
                </button>
            </ng-container>
            <!--Handling if clocking in early from a meal break-->
            <ng-container *ngIf="showClockinfromMealBreak()">
                <strong>Are you sure you want to clock in?</strong>
                <button type="button" class="btn btn-danger" [disabled]="performingClockAction"
                        *ngIf="(requestingLocation || !geolocationEnabled)"
                        (click)="postClockAction(true)">
                    Yes, Clock In Without Location
                </button>
                <button type="button" class="btn btn-success" [disabled]="performingClockAction"
                        *ngIf="!requestingLocation && position != null"
                        (click)="postClockAction(false)">
                    Yes, Clock In
                </button>
                <button type="button" class="btn btn-outline-dark"
                        (click)="performLoginRedirect()">
                    Cancel
                </button>
            </ng-container>

        </div>
    </div>

    <div class="row" *ngIf="requireSign && clockStatus && !(!kioskLogin && clockActionPerformed) && !clockActionPerformed">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block"></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            <div class="alert alert-warning" *ngIf="customMsg != null">
                <quill-view disabled [content]="customMsg"></quill-view>
            </div>
            <div class="card border" [style.width.px]="panelWidth" style="margin-bottom:20px">
                <div class="card-body" [style.width.px]="panelWidth" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
                    <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
                    <div class="m-signature-pad">
                        <div class="m-signature-pad--body" style="width: 550px;" [ngClass]="{ 'invalid': redBorder == true}" [hidden]="submitSignImg != null">
                            <signature-pad [options]="signaturePadOptions" #signaturePad></signature-pad>
                        </div>
                        <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                            <img [src]="submitSignImg" [style.max-width.px]="panelWidth - 50" />
                        </div>
                        <div class="m-signature-pad--footer">
                            <div style="text-align: center;font-size: 12px;">Sign above</div>
                            <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                            <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="!hideClick">Generate Signature</button>
                            <div class="alert alert-warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn btn-success" type="button" (click)="clockOutClicked()" [disabled]="disableSubmitSign">Submit Clock-Out</button>
        </div>
    </div>
    <div class="row" *ngIf="showClockInTypes()">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block"></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            <div class="card border">
                <div class="card-body row">
                    <div class="d-none d-lg-block col-xl-2 col-lg-2"></div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                        <div *ngIf="types?.length > 1">
                            <label><strong>Type:</strong></label>
                            <ng-select style="margin-bottom: 12px;"
                                       [items]="types"
                                       bindLabel="DisplayValue"
                                       bindValue="Value"
                                       [clearable]="false"
                                       [(ngModel)]="formData.selectedType"
                                       dropdownPosition="bottom"
                                       (change)="typeChanged()">
                            </ng-select>
                        </div>

                        <div *ngIf="formData.selectedType==='J'">
                            <app-job-type-dropdown
                                [inputJob]="formData.selectedJob"
                                [inputPhase]="formData.selectedPhase"
                                [inputEquipment]="formData.selectedEquipment"
                                [employeeInfo]="employeeInfo"
                                (dropdownChanged)="onJobDropdownChange($event)">
                            </app-job-type-dropdown>
                        </div>

                        <div *ngIf="formData.selectedType==='S'">

                            <label><strong>Trip:</strong></label>
                            <ng-select style="margin-bottom: 12px;"
                                       [items]="workOrderList"
                                       bindLabel="Display"
                                       [clearable]="false"
                                       [(ngModel)]="formData.selectedWorkOrder"
                                       dropdownPosition="bottom"
                                       (change)="workOrderChanged()"
                                       [searchable]="true">
                            </ng-select>
                            <label><strong>Scope:</strong></label>
                            <ng-select style="margin-bottom: 12px;"
                                       [items]="scopeList"
                                       bindLabel="Display"
                                       [clearable]="false"
                                       [(ngModel)]="formData.selectedScope"
                                       dropdownPosition="bottom"
                                       [searchable]="true">
                            </ng-select>
                            <label><strong>Pay Type:</strong></label>
                            <ng-select style="margin-bottom: 12px;"
                                       [items]="payTypeList"
                                       bindLabel="Display"
                                       [clearable]="false"
                                       [(ngModel)]="formData.selectedPayType"
                                       dropdownPosition="bottom"
                                       [searchable]="true">
                            </ng-select>
                        </div>

                        <div *ngIf="formData.selectedType === 'M'">
                            <app-mechanical-dropdown (dropdownChanged)="onMechanicDropdownChange($event)"></app-mechanical-dropdown>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <!--Regular clock handling if not restricted by meal break-->
                                <ng-container *ngIf="!mealBreak || canMealBreakClockIn()">
                                    <button type="button" class="btn btn-danger" [disabled]="disableClockInButton()"
                                            *ngIf="(requestingLocation || !geolocationEnabled)"
                                            (click)="postClockAction(true)">
                                        Clock In Without Location
                                    </button> <img src="/Cache/images/icon_load.gif" alt="Loading..." *ngIf="performingClockAction" />
                                    <button type="button" class="btn btn-success" *ngIf="!requestingLocation && position != null" [disabled]="disableClockInButton()"
                                            (click)="postClockAction(false)">
                                        Clock In
                                    </button>
                                </ng-container>
                                <!--Handling if clocking in early from a meal break-->
                                <ng-container *ngIf="mealBreak && !canMealBreakClockIn()">
                                    <strong>Are you sure you want to clock in?</strong>
                                    <button type="button" class="btn btn-danger" [disabled]="disableClockInButton()"
                                            *ngIf="(requestingLocation || !geolocationEnabled)"
                                            (click)="postClockAction(true)">
                                        Yes, Clock In Without Location
                                    </button> <img src="/Cache/images/icon_load.gif" alt="Loading..." *ngIf="performingClockAction" />
                                    <button type="button" class="btn btn-success" *ngIf="!requestingLocation && position != null" [disabled]="disableClockInButton()"
                                            (click)="postClockAction(false)">
                                        Yes, Clock In
                                    </button>
                                    <button type="button" class="btn btn-outline-dark"
                                            (click)="performLoginRedirect()">
                                        Cancel
                                    </button>
                                </ng-container>

                            </div>
                        </div>
                    </div>
                    <div class="d-none d-lg-block col-xl-2 col-lg-2"></div>
                </div>
            </div>
        </div>

    </div>
</div>